export default __webpack_public_path__ + "static/media/tutorial-04.c98c3c00.jpg";